export default "__VITE_ASSET__BRdFdb2w__"